import React from "react";
import useDeviceInfo from "../hooks/useDeviceInfo"; // adjust path as needed
import "./ResponsiveInput.css";
import question_mark_img from '../assets/material_icons/question_mark.svg';

const ResponsiveInput = ({
  label,
  value,
  onChange,
  onClick,
  onBlur,
  helpAction,
  ...inputProps
}) => {
  const { deviceType } = useDeviceInfo(); // returns "phone", "tablet", or "desktop"

  return (
    <div className={`responsive-input ${deviceType}`}>
      <label className="responsive-input-label ">{label}</label>
      <div className="responsive-input-wrapper">
        <input
          type="number"
          value={value}
          onChange={onChange}
          onClick={onClick}
          onBlur={onBlur}
          {...inputProps}
        />
        {helpAction && (
          <button className="help-button" onClick={helpAction}>
            <img className="help-image" src={question_mark_img} alt="Help" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ResponsiveInput;